export function createShare(link: string, name: string, t: Function): { body: string; subject: string } {
    return {
        body: t('type_share_create_body', { link, name }),
        subject: t('type_share_create_subject', { name }),
    };
}

export default createShare;
